import React from 'react';
import { Helmet } from 'react-helmet-async';

const Team = ({isHome}) => {
  const teamMembers = [
    {
      name: "Dr. Youssef Lachhab",
      specialty: "Orthodontie et Chirurgie",
      experience: "15+ years",
      education: "DDS, University of California",
      description: "Dr Youssef Lachhab, spécialiste en orthodontie et chirurgie dentaire, met son expertise au service de votre sourire avec des soins personnalisés et de haute précision.",
      phone: "+1 (555) 123-4567",
      email: "drlachhab.youssef@gmail.com",
      image: "/images/yousef.jpg"
    },
    {
      name: "Dr. Oumaima Salleh",
      specialty: "Femmes et Enfants",
      experience: "12+ years",
      education: "DDS, Harvard School of Dental Medicine",
      description: "Dr Oumaima Salleh vous accueille avec douceur et professionnalisme pour des soins dentaires de qualité, dédiés aux femmes et aux enfants, dans une atmosphère sereine et bienveillante.",
      phone: "+1 (555) 123-4568",
      email: "dr.Oumaima@gmail.com",
      image: "👩‍⚕️"
    },
    {
      name: "Marwa",
      specialty: "Assistante Administrative",
      experience: "8+ years",
      education: "DDS, Pediatric Dentistry Residency",
      description: "Marwa, assistante dentaire administrative, met à profit plus de 5 ans d’expérience pour assurer une gestion fluide de l’accueil et de l’organisation du cabinet, tout en garantissant un accompagnement chaleureux et professionnel des patients.",
      phone: "",
      email: "",
      image: "👩‍⚕️"
    },
    {
      name: "Karima",
      specialty: "Assistante Clinique",
      experience: "20+ years",
      education: "DDS, Oral Surgery Fellowship",
      description: "Karima, assistante clinique, possède plus de 10 ans d’expérience dans le domaine dentaire, offrant un soutien précieux aux chirurgiens-dentistes lors des interventions et veillant au confort des patients.",
      phone: "",
      email: "",
      image: "👩‍⚕️"
    }
  ];

  return (
    <>
      {!isHome && (
        <Helmet>
          <title>Notre Équipe – Cabinet Dentaire Temara</title>
          <meta
            name="description"
            content="Rencontrez notre équipe d'experts dentaires à Temara : Dr Youssef Lachhab (Orthodontie & Chirurgie), Dr Oumaima Salleh (Femmes & Enfants)."
          />
          <meta
            property="og:title"
            content="Notre Équipe – Cabinet Dentaire Temara"
          />
          <meta
            property="og:description"
            content="Découvrez notre équipe de professionnels dentaires expérimentés et dévoués à votre sourire et bien-être."
          />
          <meta
            property="og:image"
            content="https://centredentairetemara.ma/images/logo_horizontal_no_background.png"
          />
          <meta
            property="og:url"
            content="https://centredentairetemara.ma/team"
          />
          <meta property="og:type" content="website" />
        </Helmet>
      )}
      <section id="team" className="section-padding bg-white pt-24">
        <div className="container-custom">
          {/* Header */}
          <div className="text-center mb-16" data-aos="fade-up">
            <h2 className="text-4xl font-bold text-gray-800 mb-4">
              Rencontrez notre{" "}
              <span className="text-gradient">Équipe d'Experts</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Notre équipe de chirurgiens-dentistes et de professionnels de
              santé dentaire, expérimentés et à l’écoute, s’engage à vous offrir
              des soins de qualité optimale dans un cadre rassurant et
              chaleureux.
            </p>
          </div>

          {/* Team Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg overflow-hidden card-hover"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                {/* Header with Image */}
                <div className="bg-gradient-to-r from-blue-500 to-gray-500 p-8 text-white text-center">
                {typeof member.image === "string" && member.image.startsWith("/") ? (
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-32 h-32 mx-auto mb-4 rounded-full object-cover object-top border-4 border-white"
                  />
                ) : (
                  <div className="text-6xl mb-4">{member.image}</div>
                )}
                  <h3 className="text-2xl font-bold mb-2">{member.name}</h3>
                  <p className="text-lg opacity-90 mb-2">{member.specialty}</p>
                </div>

                {/* Content */}
                <div className="p-8">
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {member.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Team; 